export default {_name:'card.simple',module:'Field',view:'Element/Card',webOptions:{sm:2,xs:12},mobileOptions:{ms:2}}